import { Button, Card, Empty, List, Tag, Typography } from 'antd';
import { FC, ReactElement } from 'react';
import { ChevronRight, JournalRichtext } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

import { AppRoutes } from '@/common/interfaces';

import { Page, PageUsageForTag } from '@/modules/Pages';

interface Props {
  siteId: string;
  pages: Pick<Page, 'id' | 'title' | 'usageFor'>[];
}

const { Text, Paragraph } = Typography;

export const PagesLinkedPagesList: FC<Props> = ({ siteId, pages }) => {
  return (
    <Card size="small" styles={{ body: { paddingTop: 0 } }}>
      <List
        className="app-list"
        dataSource={ pages }
        locale={{
          emptyText: <Empty image={ Empty.PRESENTED_IMAGE_SIMPLE } description="Немає варіантів сторінки"/>
        }}
        header={
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              position: 'sticky'
            }}
          >
            <Text strong>
              Інші варіанти цієї сторінки <Tag color="blue">{ pages?.length ?? 0 }</Tag>
            </Text>
            { <JournalRichtext size={ 22 }/> }
          </div>
        }
        renderItem={ (item): ReactElement => (
          <List.Item
            actions={ [
              <Link
                key="view"
                to={ AppRoutes.PagesById.replace(':siteId', siteId).replace(':pageId', item.id) }
              >
                <Button type="text" icon={ <ChevronRight size={ 20 }/> }/>
              </Link>
            ] }
          >
            <List.Item.Meta
              title={
                <Paragraph style={{ marginBottom: 0 }} ellipsis={{ rows: 1, tooltip: true }}>
                  { item.title }
                </Paragraph>
              }
              description={ <PageUsageForTag value={ item.usageFor }/> }
            />
          </List.Item>
        ) }
      />
    </Card>
  );
};
